<template>
    <div class="work-template">
        <div class="work-template-header" v-bind:style="{ 'background-image': 'url(' + imageMainUrl + ')' }">
            <router-link class="work-template-header__close-btn-link" to="/work/case-studies">
                <img class="work-template-header__close-btn" src="/assets/imgs/close.png" alt="Close">
            </router-link>

            <div class="work-template-header__logo">
                <img class="work-template-header__logo-image" :src=logoUrl :alt=logoAltText>
            </div>

            <div class="work-template-header__heading-container">
                <h1 class="work-template-header__heading" v-html=title></h1>
                <h2 class="work-template-header__sub-heading" v-html=subTitle></h2>
            </div>
        </div>

        <div class="work-template-content">
            <p class="work-template-content__paragraph" v-html=description></p>
        </div>

        <div class="work-template-filters">
            <div class="work-template-filters__logo-image-container">
                <img class="work-template-filters__logo-image" src="/assets/imgs/H-blue.png" alt="H:">
            </div>

            <div class="work-template-filters__list">
                <template v-for="filter in filtersArray">
                    <li class="work-template-filters__list-item">
                        <!--<router-link class="work-template-filters__link" to="work/explore" v-html=filter.Label></router-link>-->
                        <div class="work-template-filters__link" v-html=filter.Label></div>
                    </li>
                </template>
            </div>
        </div>

        <div class="work-template-related">
            <h3 class="work-template-related__heading">Related Work</h3>

            <ul class="work-template-related__list">
                <li v-for="related in relatedArray" class="work-template-related__item">
                    <router-link :to='related.Slug' class="work-template-related__item-link">
                        <div class="work-template-related__item-content">
                            <h2 class="work-template-related__item-heading" v-html=related.Title></h2>
                            <h3 class="work-template-related__item-sub-heading" v-html=related.TitleSub></h3>
                        </div>

                        <img class="work-template-related__item-image"  :src=related.Image.Related :alt=related.Image.Related>
                    </router-link>
                </li>
            </ul>
        </div>

        <div class="work-template-footer">
            <div class="work-template-footer__link-container">
                <router-link to="/work/case-studies" class="work-template-footer__link">View More Work</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .work-template-header {
        background-attachment: fixed;
        background-size: 100% auto;
        background-repeat: no-repeat;
        margin-bottom: 60px;
        overflow: hidden;
        padding-top: 0;
        position: relative;

        @media @breakpoint__tablet--small {
            margin-bottom: 0;
            padding-top: 49%;
        }
    }

    .work-template-header__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .work-template-header__close-btn {
        cursor: pointer;
        display: block;
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .work-template-header__logo {
        background: #fff;
        border-bottom-left-radius: 45px;
        border-bottom-right-radius: 45px;
        padding: 15px 50px 30px;
        position: absolute;
        right: 15%;
        text-align: center;
        transform: translateY(-100%);
        top: 0px;
        z-index: 10;

        @media @breakpoint__tablet--large {
            right: 12%;
        }

        @media @breakpoint__tablet--medium {
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
            padding: 12px 40px 20px;
            right: 15%;
        }

        @media @breakpoint__tablet--small {
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
            opacity: 0;
            padding: 30px 40px 30px;
            position: relative;
            right: 0;
            transform: translateY(40px);
        }
    }

    .work-template-header__logo-image {
        width: 160px;

        @media @breakpoint__tablet--large {
            width: 100px;
        }
    }

    .work-template-header__heading-container {
        background: #fff;
        border-top-left-radius: 45px;
        border-top-right-radius: 45px;
        bottom: 0px;
        box-sizing: border-box;
        margin: 0;
        padding: 25px 20px 25px;
        position: absolute;
        right: 15%;
        text-align: center;
        transform: translateY(100%);
        width: 260px;
        z-index: 10;

        @media @breakpoint__tablet--large {
            right: 12%;
            width: 200px;
        }

        @media @breakpoint__tablet--medium {
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            padding: 20px 20px 15px;
            right: 15%;
            width: 180px;
        }

        @media @breakpoint__tablet--small {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            opacity: 0;
            padding: 0 30px 30px;
            position: relative;
            right: 0;
            transform: translateY(40px);
            width: 100%;
        }

        .work-template-header__heading {
            color: #003a4a;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 22px;
            letter-spacing: 1px;
            margin: 0 0 10px 0;
            text-transform: uppercase;

            @media @breakpoint__tablet--large {
                font-size: 14px;
            }

            @media @breakpoint__tablet--small {
                font-size: 20px;
            }
        }

        .work-template-header__sub-heading {
            color: #e40046;
            font-size: 20px;
            letter-spacing: 1px;
            margin: 0;

            @media @breakpoint__tablet--large {
                font-size: 14px;
            }

            @media @breakpoint__tablet--small {
                font-size: 18px;
            }
        }
    }

    .work-template-header__image {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 0;
    }

    .work-template-content {
        background-color: #ffffff;
        box-sizing: border-box;
        margin: 0 auto 50px;
        max-width: 1300px;
        padding: 0 50px;
        position: relative;
        width: 100%;
        z-index: 10;

        @media @breakpoint__mobile--large {
            margin: 0 auto 40px;
            padding: 0;
        }
    }

    .work-template-filters {
        display: flex;
        margin: 0 auto 80px;
        max-width: 600px;
        opacity: 0;
        padding: 0 50px;
        transform: translateY(20px);

        @media @breakpoint__mobile--large {
            box-sizing: border-box;
            padding: 0 20px;
        }
    }

    .work-template-filters__logo-image-container {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .work-template-filters__logo-image {

        @media @breakpoint__mobile--large {
        }
    }

    .work-template-filters__list {
        list-style-type: none;
        padding: 0;
        margin: 0 0 0 65px;
        padding: 0;
        max-width: 700px;
        text-align: left;
    }

    .work-template-filters__list-item {
        display: inline-block;
        margin: 10px 5px;

        @media @breakpoint__mobile--large {
            margin: 5px 5px;
        }
    }

    .work-template-filters__link {
        border: 1px solid #e40046;
        border-radius: 5px;
        background: #fff;
        color: #003a4a;
        cursor: default;
        display: block;
        font-size: 18px;
        letter-spacing: 0.2px;
        line-height: 23px;
        padding: 1px 5px 1px;
        text-decoration: none;
        text-transform: uppercase;
        transition: 0.4s all;

        &:focus {
            outline: none;
        }

        &:hover {
            //background: #e40046;
            //color: #ffffff;
        }

        &.active {
            background: #e40046;
            color: #ffffff;

            &:hover {
                border: 1px solid #e40046;
            }
        }

        &.disabled {
            border: 1px solid #003a4a;
            cursor: default;
            opacity: 0.3;
        }

        @media @breakpoint__mobile--large {
            font-size: 13px;
        }
    }

    .work-template-related {
        background-color: #ffffff;
        max-width: 1300px;
        margin: 0 auto 20px;
        position: relative;
        z-index: 10;
    }

    .work-template-related__heading {
        color: #003a4a;
        font-size: 30px;
        font-weight: 400;
        letter-spacing: 0.38px;
        margin: 0 0 35px 0;
        opacity: 0;
        text-align: center;
        text-transform: uppercase;
        transform: translateY(50px);
    }

    .work-template-related__list {
        box-sizing: border-box;
        margin: 0;
        padding: 0 50px;
        width: 100%;

        @media @breakpoint__mobile--large {
            padding: 0 20px;
        }
    }

    .work-template-related__item {
        box-sizing: border-box;
        display: inline-block;
        list-style-type: none;
        margin: 0 0 50px 50px;
        opacity: 0;
        transform: translateY(20px);
        width: calc(~"(100% / 3) - (50px / 3 * 2)");
        vertical-align: top;

        &:first-child {
            margin: 0 0 50px 0;

            @media @breakpoint__mobile--large {
                margin: 0 0 20px;
            }
        }

        @media @breakpoint__tablet--medium {
            margin: 0 0 50px 15px;
            width: calc(~"(100% / 3) - (15px / 3 * 2)");
        }

        @media @breakpoint__tablet--small {
            margin:0 0 50px;
            padding: 0;
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            margin: 0 0 20px;
            padding: 0;
            width: 100%;
        }

        .news-explore-articles__image {
            display: block;
            width: 100%;
        }
    }

    .work-template-related__item-link {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        border-radius: 62px;
        display: block;
        font-family: Flama, Arial, Helvetica, sans-serif;
        overflow: hidden;
        position: relative;

        &:before {
            content: "";
            background-color: #003A4A;
            height: 100%;
            left: 0;
            opacity: 0;
            position: absolute;
            transition: 0.3s opacity;
            top: 0;
            width: 100%;
        }

        @media @breakpoint__tablet--large {
            border-radius: 30px;

            &:before {
                opacity: 0.78;
            }
        }

        @media @breakpoint__mobile--large {
            border-radius: 40px;
        }

        &:hover {
            &:before {
                opacity: 0.78;
            }

            .work-template-related__item-heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.1s;
            }

            .work-template-related__item-sub-heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.2s;
            }
        }
    }

    .work-template-related__item-content {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        z-index: 10;
    }

    .work-template-related__item-heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        letter-spacing: 1px;
        margin: 0 0 10px 0;
        text-transform: uppercase;

        @media @breakpoint__tablet--large {
            font-size: 14px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 14px;
        }

        @media @breakpoint__tablet--small {
            font-size: 20px;
        }
    }

    .work-template-related__item-sub-heading {
        color: #e40046;
        font-size: 22px;
        font-weight: normal;
        letter-spacing: 1px;
        margin: 0;

        @media @breakpoint__tablet--large{
            font-size: 14px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 14px;
        }

        @media @breakpoint__tablet--small {
            font-size: 20px;
        }
    }

    .work-template-related__item-heading,
    .work-template-related__item-sub-heading {
        opacity: 0;
        transform: translateY(40px);
        transition: 0.3s opacity, 0.3s transform;
        transition-delay: 0;

        @media @breakpoint__tablet--large {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .work-template-related__item-image {
        display: block;
        width: 100%;
    }

    .work-template-footer {
        opacity: 0;
        padding: 0 20px 60px;
    }

    .work-template-footer__link-container {
        display: block;
        text-align: center;
    }

    .work-template-footer__link {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 16px;
        letter-spacing: 0.6px;
        min-width: 110px;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        z-index: 20;

        @media @breakpoint__mobile--small {
            display: table;
            margin: 0 auto 20px;
        }
    }
</style>

<style lang="less">
    @import "../less/breakpoints.less";

    .work-template-content__paragraph {
        color: #003a4a;
        font-size: 20px;
        letter-spacing: 0.7px;
        line-height: 1.6;
        margin: 0;
        opacity: 0;
        padding: 0;
        text-align: center;
        transform: translateY(50px);

        @media @breakpoint__mobile--large {
            font-size: 16px;
            padding: 0 20px;
            text-align: left;
        }

        strong {
            color: #e40046;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        }
    }
</style>

<script>
    export default {
        name: "WorkTemplate",
        data() {
            return {
                description : "",
                filtersArray : [],
                imageMainAltText : "",
                imageMainUrl : "",
                logoAltText : "",
                logoUrl : "",
                relatedArray: [],
                subTitle: "",
                title: ""
            }
        },
        created: function()
        {
            var vm = this;
            vm.$parent.backgroundColor = "light";
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelWorkGallery))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initContent(vm.$parent.modelWorkGallery, vm.$parent.modelWorkFilters);
                }
            }, 500);
        },
        mounted : function()
        {
            TweenMax.set(".header-nav-button-container", {display:"none"});
            TweenMax.set(".header__logo-container", {display: "none"});
        },
        methods: {
            initContent: function(workGalleryData, filtersData)
            {
                var caseStudyData = this.findObjectByKey(workGalleryData, "Slug", this.$route.params.id);
                this.description = caseStudyData.Description;
                this.imageMainAltText = caseStudyData.Image.AltText;
                this.imageMainUrl = caseStudyData.Image.Main;
                this.logoAltText = caseStudyData.Logo.AltText;
                this.logoUrl = caseStudyData.Logo.Image;
                this.title = caseStudyData.Title;
                this.subTitle = caseStudyData.TitleSub;

                for (var i = 0; i < caseStudyData.Related.length; i++)
                {
                    this.relatedArray.push(this.findObjectByKey(workGalleryData, "Slug", caseStudyData.Related[i].Slug));
                }

                for (var ii = 0; ii < caseStudyData.Filters.length; ii++)
                {
                    this.filtersArray.push(this.findObjectByKey(filtersData, "Id", caseStudyData.Filters[ii]));
                }

                var vm = this;
                setTimeout(function()
                {
                    vm.onEnter();
                }, 500);
            },
            onEnter : function()
            {
                function getBgUrl(el)
                {
                    var bg = "";

                    if (el.currentStyle)
                    {
                        bg = el.currentStyle.backgroundImage;
                    }
                    else if (document.defaultView && document.defaultView.getComputedStyle)
                    {
                        bg = document.defaultView.getComputedStyle(el, "").backgroundImage;
                    }
                    else
                    {
                        bg = el.style.backgroundImage;
                    }

                    return bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
                }

                var image = document.createElement('img');
                image.src = getBgUrl(document.querySelector(".work-template-header"));
                image.onload = function ()
                {
                    var tl = new TimelineMax();
                    tl.to(".work-template-header", 0.7, {paddingTop: "48%", ease: Power3.easeOut});
                    tl.to(".work-template-header__logo", 0.8, {transform: "translateY(0)", opacity: 1, ease: Power3.easeOut}, "-=0.4");
                    tl.to(".work-template-header__heading-container", 0.8, {transform: "translateY(0)", opacity: 1, ease: Power3.easeOut}, "-=0.6");
                    tl.to(".work-template-header__close-btn", 0.6, {transform: "scale(1)", ease: Back.easeOut.config(2)}, "-=0.6");
                    tl.to(".work-template-content__paragraph", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.4");
                    tl.to(".work-template-filters", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.2");
                    tl.to(".work-template-related__heading", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.2");
                    tl.staggerTo(".work-template-related__item", 0.5, {opacity: 1, transform: "translateY(0)", ease: Power2.easeOut}, 0.2, "-=0.2");
                    tl.to(".work-template-footer", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.2");
                };
            }
        },
        watch:
        {
            '$route' (to, from)
            {
                this.$parent.templateName = to.path;
            }
        }
    };
</script>
